
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class QueryPropertyModel extends Model<QueryPropertyModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'name', type: 'string', languageString: 'queryProperty.property.name' },
		{ name: 'entityName', type: 'string', languageString: 'queryProperty.property.entityName' },
		{ name: 'type', type: 'QueryPropertyType', languageString: 'queryProperty.property.type' },
		{ name: 'valueType', type: 'QueryPropertyValueType', languageString: 'queryProperty.property.valueType' },
		{ name: 'options', type: 'Record<string, string>', languageString: 'queryProperty.property.options', isArray: true, isDictionary: true },
		{ name: 'nullable', type: 'boolean', languageString: 'queryProperty.property.nullable' },
		{ name: 'customProperty', type: 'CustomPropertyType', languageString: 'queryProperty.property.customProperty' },
		{ name: 'foreignKeyProperty', type: 'string', languageString: 'queryProperty.property.foreignKeyProperty' },
		{ name: 'queryType', type: 'string', languageString: 'queryProperty.property.queryType' }
	];
	[key: string]: any;
	
	public name: string;
	public entityName: string;
	public type: QueryPropertyType;
	public valueType: QueryPropertyValueType;
	public options: Record<string, string>;
	public nullable: boolean;
	public customProperty?: CustomPropertyType;
	public foreignKeyProperty: string;
	public queryType: string;
    
	constructor(){
		super();
		this.name = '';
		this.entityName = '';
		this.type = 0;
		this.valueType = 0;
		this.options = {};
		this.nullable = false;
		this.customProperty = undefined;
		this.foreignKeyProperty = '';
		this.queryType = '';
		
	}
	getProperties(){
		return QueryPropertyModel.classProperties;
	}
}

export enum QueryPropertyType{
	Value = 0,
	Query = 1,
	Custom = 2,
	Select = 3,
	InputUserId = 4,
	InputCompanyId = 5,
	InputTeamId = 6,
	InputBrandId = 7,
	InputReasonId = 8,
	InputTaskAreaId = 9
}
export namespace QueryPropertyType {
	export function getKeys(): Map<QueryPropertyType, string> {
		return new Map([[0, 'Value'], [1, 'Query'], [2, 'Custom'], [3, 'Select'], [4, 'InputUserId'], [5, 'InputCompanyId'], [6, 'InputTeamId'], [7, 'InputBrandId'], [8, 'InputReasonId'], [9, 'InputTaskAreaId']]);
	}
}
export enum QueryPropertyValueType{
	Text = 0,
	Numeric = 1,
	Date = 2,
	DateTime = 3,
	Time = 4,
	Boolean = 5
}
export namespace QueryPropertyValueType {
	export function getKeys(): Map<QueryPropertyValueType, string> {
		return new Map([[0, 'Text'], [1, 'Numeric'], [2, 'Date'], [3, 'DateTime'], [4, 'Time'], [5, 'Boolean']]);
	}
}
export enum CustomPropertyType{
	TaskTemplateTag = 0,
	TaskflowTemplateTag = 1,
	TaskActionOnActiveStep = 2,
	CompanyPrimaryResponsible = 3,
	ProductPlanTag = 4,
	ProductTag = 5,
	OrderHasAttachments = 6,
	OrderLineProductTag = 7
}
export namespace CustomPropertyType {
	export function getKeys(): Map<CustomPropertyType, string> {
		return new Map([[0, 'TaskTemplateTag'], [1, 'TaskflowTemplateTag'], [2, 'TaskActionOnActiveStep'], [3, 'CompanyPrimaryResponsible'], [4, 'ProductPlanTag'], [5, 'ProductTag'], [6, 'OrderHasAttachments'], [7, 'OrderLineProductTag']]);
	}
}
